import { render, staticRenderFns } from "./icon-selector.vue?vue&type=template&id=e2c26f64&"
import script from "./icon-selector.vue?vue&type=script&lang=js&"
export * from "./icon-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports